export const products47 = [
  {
    id: 549,
    imgSrc: "/assets/images/home/demo22/product-1.jpg",
    category: "Dresses",
    title: "WORXSAW Compact Circular Saw",
    price: 29,
  },
  {
    id: 550,
    imgSrc: "/assets/images/home/demo22/product-2.jpg",
    category: "Dresses",
    title: "Cordless String Trimmer",
    price: 29,
  },
  {
    id: 551,
    imgSrc: "/assets/images/home/demo22/product-3.jpg",
    category: "Dresses",
    title: "Amp Electric 18 Chainsaw",
    price: 29,
  },
  {
    id: 552,
    imgSrc: "/assets/images/home/demo22/product-4.jpg",
    category: "Dresses",
    title: "BladeRunner Portable Table Top Saw",
    price: 29,
  },
  {
    id: 553,
    imgSrc: "/assets/images/home/demo22/product-1.jpg",
    category: "Dresses",
    title: "WORXSAW Compact Circular Saw",
    price: 29,
  },
  {
    id: 554,
    imgSrc: "/assets/images/home/demo22/product-2.jpg",
    category: "Dresses",
    title: "Cordless String Trimmer",
    price: 29,
  },
  {
    id: 555,
    imgSrc: "/assets/images/home/demo22/product-3.jpg",
    category: "Dresses",
    title: "Amp Electric 18 Chainsaw",
    price: 29,
  },
  {
    id: 556,
    imgSrc: "/assets/images/home/demo22/product-4.jpg",
    category: "Dresses",
    title: "BladeRunner Portable Table Top Saw",
    price: 29,
  },
];
export const products48 = [
  {
    id: 557,
    imgSrc: "/assets/images/home/demo22/product-5.jpg",
    category: "Dresses",
    title: "Cordless String Trimmer",
    price: 32,
    filterCategory: "New",
  },
  {
    id: 558,
    imgSrc: "/assets/images/home/demo22/product-6.jpg",
    category: "Dresses",
    title: "Amp Electric 18 Chainsaw",
    price: 32,
    filterCategory: "On Sale",
  },
  {
    id: 559,
    imgSrc: "/assets/images/home/demo22/product-7.jpg",
    category: "Dresses",
    title: "BladeRunner Portable Table Top Saw",
    price: 32,
    filterCategory: "New",
  },
  {
    id: 560,
    imgSrc: "/assets/images/home/demo22/product-8.jpg",
    category: "Dresses",
    title: "Cordless String Trimmer",
    price: 32,
    filterCategory: "On Sale",
  },
  {
    id: 561,
    imgSrc: "/assets/images/home/demo22/product-9.jpg",
    category: "Dresses",
    title: "Amp Electric 18 Chainsaw",
    price: 32,
    filterCategory: "On Sale",
  },
  {
    id: 562,
    imgSrc: "/assets/images/home/demo22/product-10.jpg",
    category: "Dresses",
    title: "BladeRunner Portable Table Top Saw",
    price: 32,
    filterCategory: "New",
  },
];

export const products49 = [
  {
    id: 563,
    style: {
      left: "45%",
      top: "14%",
    },
    imgSrc: "/assets/images/home/demo22/product-11.jpg",
    title: "RISE & SHINE",
    price: 34,
    category: "Dresses",
  },
  {
    id: 564,
    style: {
      left: "31%",
      top: "55%",
    },
    imgSrc: "/assets/images/home/demo22/product-11.jpg",
    title: "RISE & SHINE",
    price: 34,
    category: "Dresses",
  },
  {
    id: 565,
    style: {
      left: "55%",
      top: "71%",
    },
    imgSrc: "/assets/images/home/demo22/product-11.jpg",
    title: "RISE & SHINE",
    price: 34,
    category: "Dresses",
  },
];
